export const CountryList = [
    {
        isoCode: "tg",
        name: "TOGO",
        code: "+228",
        digit: 8,
        currency: "xof",
        payments: [],
    },
    {
        isoCode: "bj",
        name: "BENIN",
        code: "+229",
        digit: 10,
        currency: "xof",
        payments: [],
    },
    {
        isoCode: "cm",
        name: "CAMEROON",
        code: "+237",
        digit: 9,
        currency: "xaf",
        payments: [],
    },
    {
        isoCode: "sn",
        name: "SENEGAL",
        code: "+221",
        digit: 9,
        currency: "xof",
        payments: [],
    },
    {
        isoCode: "bf",
        name: "BURKINA FASO",
        code: "+226",
        digit: 8,
        currency: "xof",
        payments: [],
    },
    {
        isoCode: "ci",
        name: "COTE D'IVOIRE",
        code: "+225",
        digit: 10,
        currency: "xof",
        payments: [],
    },
    {
        isoCode: "ml",
        name: "MALI",
        code: "+223",
        digit: 8,
        currency: "xof",
        payments: [],
    },
];